module.exports = __webpack_public_path__ + "static/media/recommendation2.9ad4624b.jpg";